import React from 'react';

import SelectedDashboard from '../../../containers/dashboards/cards/SelectedDashboard';
import DashboardEditMode from './DashboardEditMode';

const DashboardCards = ({
  selectedDashboard,
  dashboardsObj,
  dashboardName,
  setDashboardName,
  saveDashboard,
  updateDashboard,
  isEdit,
  isCreate,
  resetDashboardMode,
  units,
}) => {
  return isEdit || isCreate ? (
    <DashboardEditMode
      dashboardsObj={dashboardsObj}
      dashboardId={selectedDashboard}
      onBack={resetDashboardMode}
      isCreate={isCreate}
      dashboardName={dashboardName}
      setDashboardName={setDashboardName}
      saveDashboard={saveDashboard}
      updateDashboard={updateDashboard}
      units={units}
    />
  ) : (
    <SelectedDashboard dashboardsObj={dashboardsObj} />
  );
};

export default DashboardCards;
